

import './styles/globals.scss';
import MyForm from "./pages/MyForm";
import Completion from "./pages/Completion";
import {createBrowserRouter,RouterProvider} from 'react-router-dom';
import Root from "./Root";

const router= createBrowserRouter([
  {path:"/",
    element: <Root/>
    ,children:[
      {
        path:"/",
        element:<MyForm/>
      },
      {path:"/completion",
        element:<Completion/>
      }
    ]
  },
  

]);
function App() {
  return (
    <RouterProvider router={router}/>
  );
}

export default App;
